/* eslint-disable camelcase */
import apiRoutes from "../apiRoutes";
import { BaseCrudService } from "../baseCrudService";
import {
  Auth2FaResendCodeRequest,
  Auth2FaResendCodeResponse,
  Auth2FaVerificationResponse,
  Auth2FaVerificationRequest,
  Auth2FaRequestData,
} from "../../models/auth2FaData";

/**
 * Service for 2 factor authentication
 * @extends BaseCrudService
 */
export class Auth2FaService extends BaseCrudService {
  /**
   * Verify the 2FA code
   * @returns SecuritySettingsData
   */
  async verify2FaCode(user_id: string, code: string) {
    const payload: Auth2FaVerificationRequest = { user_id, code };

    const response = await this.create<Auth2FaVerificationRequest>(
      apiRoutes.auth.verify_2fa_code,
      payload
    );

    // We know the backend returns a detail message → cast as response
    return response.data as unknown as Auth2FaVerificationResponse;
  }

  /**
   * Resend the 2FA code to the user's email
   * @returns Response from resend request
   */

  async resend2FaCode(user_id: string) {
    const payload: Auth2FaResendCodeRequest = { user_id };

    const response = await this.create<Auth2FaResendCodeRequest>(
      apiRoutes.auth.resend_2fa_code,
      payload
    );

    // We know the backend returns a detail message → cast as response
    return response.data as unknown as Auth2FaResendCodeResponse;
  }

  /**
   * Check the password validity for current user
   *
   * @param password - The user's current password.
   * @returns A promise resolving to the server response.
   */
  async checkPassword(password: string) {
    const response = await this.create(apiRoutes.auth.check_password, {
      password,
    });
    return response;
  }

  /**
   * Send a new 2FA code to the authenticated user's email (used in settings)
   * @returns Response with detail message and signed user ID
   */
  async send2FaCode() {
    const response = await this.create<void>(apiRoutes.auth.send_2fa_code, undefined);

    return response.data as unknown as Auth2FaRequestData;
  }
}
